import React, { useEffect, useState } from "react";
import { useAuth } from "context/AuthContext"
import { Redirect, Route } from "react-router-dom"
import ErroGestaoUsuario from "EstruturaAntiga/pages/usuariosV2/ErroGestaoUsuario";
import { ehRotaDeGestaoDeUsuarios } from "utils/contextos";

const PrivateRoute = ({ component: Component, ...routeProps }) => {
    const { authorized, loading, termosAceite, ObterParametrosRelatorio, ValidaPermissaoAcessoRota, DefinirDireitoDaRota, RotaPermitidaParaMaisDeUmDireito } = useAuth();
    const [paginaAutorizada, setPaginaAutorizada] = useState(false);
    const [gestaoDeUsuariosAmbigua, setGestaoDeUsuariosAmbigua] = useState(false);
    const [caminhoVerificado, setCaminhoVerificado] = useState(null);

    const currentPath = routeProps.location.pathname.toLowerCase();
    const isOnTermosPage = currentPath === "/termosdeaceite" || currentPath === "/termosdeaceite/termo";
    const mustAcceptTerms = termosAceite.length > 0;

    useEffect(()=>{
        if(loading) return;
        const relatorioParams = ObterParametrosRelatorio(currentPath);
        const isAuthorized = ValidaPermissaoAcessoRota(currentPath, relatorioParams);
        if(isAuthorized || currentPath == "/dashboard"){
            DefinirDireitoDaRota(currentPath, relatorioParams);
        }
        setPaginaAutorizada(isAuthorized);
        setGestaoDeUsuariosAmbigua(ehRotaDeGestaoDeUsuarios(currentPath) && RotaPermitidaParaMaisDeUmDireito(currentPath, relatorioParams));
        setCaminhoVerificado(currentPath);
    },[loading, currentPath])

    if (loading || caminhoVerificado !== currentPath) return null;

    if (mustAcceptTerms && !isOnTermosPage) {
        return <Redirect to="/termosdeaceite" />;
    }

    if (!paginaAutorizada) {
        if(routeProps.location.pathname != "/dashboard"){
            return <Redirect to="/dashboard"/>;
        }
    }

    if (!authorized) {
        return <Redirect to="/login" />;
    }

    if (gestaoDeUsuariosAmbigua) {
        return <ErroGestaoUsuario />;
    }

    return <Component {...routeProps} />;
}

export default PrivateRoute
